enum Gender {
  MALE = "Male",
  FEMALE = "Female",
  OTHER = "Other",
}

export default Gender;
